import { get, post, put, _delete } from './Tools';

const getListAreas = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}area_trabajo/get/list`);
  return response;
};

const getEmpleados = async (ids) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo/empleados/get/ids`, ids);
  return response;
}

const getDepartamentos = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_departamento/list`);
  return response;
}

const getEmpleadosByDepartamento = async (department_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/departamento/${department_id}`);
  return response;
}

const getEmpleadosByArea = async (area_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/area/${area_id}`);
  return response;
}

const getTiposAusentismo = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/tipos_ausentismo`);
  return response;
}

const updateTipoIncapacidad = async (id, activo) => {
    const response = await put(`${process.env.REACT_APP_SERVER}tipo_incapacidad`,
    {
        id,
        activo
    });
    return response;
}

const updateOdooLeaveType = async (id, activo) => {
    const response = await post(`${process.env.REACT_APP_SERVER}odoo_leave_type`,
    {
        odoo_id: id,
        active: activo
    });
    return response;
}

const getIntegracion = async () => {
    const response = await get(`${process.env.REACT_APP_SERVER}integracion`);
    return response;
}

const getEmpleadosByPuesto = async (puesto_id) => {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/puesto/${puesto_id}`);
    return response;
}

const getPuestos = async () => {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo_puesto/get/all`);
    return response;
}

const upsertAguinaldoEmpleado = async (payload) => {
    const response = await post(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/upsert_empleado`, payload);
    return response;
}

const getEmpleadosSinAguinaldo = async (anio_aguinaldo) => {
    const response = await get(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/empleados_sin_aguinaldo?anio=${anio_aguinaldo}`);
    return response;
}

const getEmpleadosConAguinaldo = async (anio_aguinaldo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/aplicacion/mostrar?anio=${anio_aguinaldo}`);
  return response;
};

export { 
  getListAreas, 
  getEmpleados, 
  getDepartamentos, 
  getEmpleadosByDepartamento, 
  getEmpleadosByArea,
  getTiposAusentismo, 
  updateTipoIncapacidad, 
  updateOdooLeaveType, 
  getIntegracion, 
  upsertAguinaldoEmpleado, 
  getEmpleadosSinAguinaldo, 
  getEmpleadosConAguinaldo, 
  getEmpleadosByPuesto, 
  getPuestos 
};